import { render } from "./CertificateImportFile.vue?vue&type=template&id=a6501ec8&scoped=true"
import script from "./CertificateImportFile.vue?vue&type=script&lang=js"
export * from "./CertificateImportFile.vue?vue&type=script&lang=js"

import "./CertificateImportFile.vue?vue&type=style&index=0&id=a6501ec8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6501ec8"]])

export default __exports__